import React from 'react';
import styled from 'styled-components';

const MetaContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 40px;
  margin-top: 40px;
  padding-top: 40px;
  border-top: 1px solid rgba(0,0,0,0.1);
`;

const MetaItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  text-align: left;
`;

const IconBox = styled.div`
  color: var(--color-primary-blue);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const MetaText = styled.div`
  display: flex;
  flex-direction: column;

  strong {
    color: var(--color-text);
    font-size: 1rem;
    font-weight: 600;
  }
  
  span {
    color: var(--color-text-light);
    font-size: 0.85rem;
  }
`;

const EventMeta = ({ items }) => (
  <MetaContainer>
    {items.map((item, index) => (
      <MetaItem key={index}>
        <IconBox>
          {item.icon}
        </IconBox>
        <MetaText>
          <strong>{item.title}</strong>
          <span>{item.subtitle}</span>
        </MetaText>
      </MetaItem>
    ))}
  </MetaContainer>
);

export default EventMeta;